module.exports = __webpack_public_path__ + "static/media/chevrons-right.4eede6c8.svg";